/**
 * Shared styling constants for auth pages.
 * Avoids duplicating long Tailwind class strings across login, reset-password,
 * magic-link, update-password, request-access, and MFA pages.
 */

export const AUTH_INPUT_CLASS =
  'h-11 rounded-xl !border-[var(--color-border-primary)] bg-surface px-3.5 text-md text-[var(--color-fg-primary)] placeholder:text-[var(--color-fg-tertiary)] focus:!border-[var(--color-border-brand)] focus-visible:ring-2 focus-visible:ring-[var(--color-fg-quaternary)]/40 md:text-md dark:!border-[var(--color-border-primary)] dark:bg-[var(--color-bg-tertiary)] dark:text-[var(--color-text-primary)] dark:placeholder:text-[var(--color-text-placeholder)] dark:focus:!border-[var(--color-border-primary)] dark:focus-visible:ring-2 dark:focus-visible:ring-[var(--color-text-brand-primary)]/40';

export const AUTH_PASSWORD_INPUT_CLASS = `${AUTH_INPUT_CLASS} pr-10`;

export const AUTH_BUTTON_CLASS =
  'h-11 w-full rounded-full bg-brand-solid text-sm font-medium text-white transition-colors hover:bg-brand-solid_hover disabled:opacity-50';

export const AUTH_HEADING_CLASS =
  'text-xl font-semibold tracking-[-0.02em] text-[var(--color-fg-primary)]';

export const AUTH_DESCRIPTION_CLASS = 'mt-2 text-sm leading-[1.6] text-[var(--color-fg-secondary)]';

export const AUTH_LABEL_CLASS = 'text-xs font-medium text-[var(--color-fg-secondary)]';

export const AUTH_LINK_CLASS =
  'h-auto p-0 text-xs font-medium text-[var(--color-fg-tertiary)] underline decoration-[var(--color-fg-quaternary)] underline-offset-2 hover:text-[var(--color-fg-secondary)] hover:decoration-[var(--color-fg-tertiary)]';
